const pt = {
  "srv_general_unknown": "Algo deu errado. Tente novamente.",
  "srv_general_network": "Erro de rede. Verifique sua conexão.",
  "srv_general_timeout": "A solicitação expirou. Tente novamente.",
  "srv_general_not_found": "Não encontrado",
  "srv_general_invalid_id": "ID inválido",
  "srv_general_invalid_json": "JSON inválido",
  "srv_auth_admin_only": "Somente admin",
  "srv_auth_owner_only": "Acesso somente do proprietário",
  "srv_auth_unauthorized": "Não autorizado",
  "srv_auth_not_authenticated": "Não autenticado",
  "srv_auth_invalid_token": "Token inválido",
  "srv_auth_session_expired": "Sem token de atualização",
  "srv_auth_token_expired": "Token expirado",
  "srv_auth_device_signed_out": "Este dispositivo foi desconectado",
  "srv_auth_invalid_login": "Nome de usuário/e-mail ou senha inválidos",
  "srv_auth_wrong_password": "A senha atual está incorreta",
  "srv_auth_email_already_exists": "E-mail já cadastrado",
  "srv_auth_email_taken_other": "Este e-mail agora está em uso por outra conta",
  "srv_auth_same_email": "Este já é seu e-mail",
  "srv_auth_same_username": "Este já é seu nome de usuário",
  "srv_auth_username_taken": "Nome de usuário já está em uso",
  "srv_auth_username_invalid": "O nome de usuário deve ter 3-20 letras, números ou sublinhado",
  "srv_auth_user_not_found": "Usuário não encontrado",
  "srv_auth_password_mismatch": "As senhas não coincidem",
  "srv_auth_password_weak": "A nova senha deve ter pelo menos 8 caracteres e incluir uma letra e um número",
  "srv_auth_password_same": "A nova senha deve ser diferente da senha atual",
  "srv_auth_rate_limited": "Muitas tentativas. Tente novamente mais tarde.",
  "srv_auth_signup_rate_limited": "Muitos cadastros desta rede. Tente mais tarde.",
  "srv_auth_verify_link_invalid": "Link de verificação inválido ou já usado",
  "srv_auth_verify_link_expired": "O link de verificação expirou. Solicite um novo.",
  "srv_auth_email_already_verified": "E-mail já verificado.",
  "srv_auth_verification_sent": "E-mail de verificação enviado.",
  "srv_auth_email_change_sent": "Link de verificação enviado para o novo e-mail. Confirme-o para concluir a alteração.",
  "srv_auth_reset_link_invalid": "Link de redefinição inválido ou expirado",
  "srv_auth_reset_sent": "Se a conta existir, um link de redefinição foi enviado.",
  "srv_auth_password_updated": "Senha atualizada. Entre com sua nova senha.",
  "srv_auth_password_changed": "Senha alterada. Entre novamente nos outros dispositivos.",
  "srv_auth_signed_out_all": "Desconectado de todos os dispositivos",
  "srv_auth_signed_out_others": "Desconectado de todos os outros dispositivos",
  "srv_auth_device_revoked": "Dispositivo desconectado",
  "srv_subscription_required": "Este recurso é para membros Premium",
  "srv_subscription_plan_unavailable": "O plano de teste não está disponível.",
  "srv_subscription_order_not_found": "Pedido não encontrado",
  "srv_payment_provider_unreachable": "Não foi possível acessar o provedor de pagamento. Tente novamente.",
  "srv_payment_invoice_failed": "O provedor de pagamento não conseguiu criar a fatura. Tente novamente.",
  "srv_payment_not_configured": "O gateway de pagamento em cripto ainda não está configurado. Adicione as chaves API do NOWPayments.",
  "srv_payment_invalid_signature": "Assinatura inválida",
  "srv_exchange_connection_not_found": "Conexão não encontrada",
  "srv_exchange_unsupported": "Exchange não compatível",
  "srv_exchange_unreachable": "Exchange inacessível pelo servidor",
  "srv_exchange_key_not_readonly": "Esta chave API tem permissões de trade/saque. Crie uma chave SOMENTE LEITURA (desative Trade e Withdraw).",
  "srv_exchange_verify_first": "Verifique a conexão antes de ativar o trading ao vivo",
  "srv_insufficient_balance": "O valor excede seu saldo disponível",
  "srv_trade_amount_positive": "O valor deve ser maior que 0",
  "srv_trade_invalid_withdrawal": "Valor de saque inválido",
  "srv_trade_bot_needs_tp_sl": "O bot exige Stop Loss e Take Profit",
  "srv_trade_no_position": "Não há posição aberta para vender",
  "srv_trade_position_not_found": "Posição não encontrada",
  "srv_trade_symbol_required": "O símbolo é obrigatório",
  "srv_trade_invalid_symbol": "Símbolo inválido",
  "srv_trade_invalid_interval": "Intervalo inválido",
  "srv_trade_verify_email": "Verifique seu e-mail antes de abrir operações.",
  "srv_trade_verify_email_auto": "Verifique seu e-mail antes de ativar o trading automático.",
  "srv_trade_demo_min": "O saldo demo mínimo é 100",
  "srv_trade_demo_max": "O saldo demo é muito alto (máx. 10,000,000)",
  "srv_trade_leverage_confirm": "Alavancagem acima de 20x requer confirmação dupla",
  "srv_trade_high_risk_confirm": "Risco acima de 15% requer confirmação de Alto Risco",
  "srv_trade_high_liquidation_risk": "Alto risco de liquidação",
  "srv_trade_no_fee": "Sem taxa (mantido por 7+ dias).",
  "srv_insufficient_data": "Dados de candles insuficientes para este backtest",
  "srv_notification_not_found": "Notificação não encontrada",
  "srv_nft_image_failed": "Falha ao gerar imagem",
  "ntf_cloud_enabled": "Trading em nuvem ativado — o bot opera 24/7.",
  "ntf_cloud_disabled": "Trading em nuvem desativado.",
  "srv_trade_no_price": "Sem preço disponível para {symbol}",
  "srv_trade_risk_lock": "Bloqueio de risco: máx. {pct}% do saldo por operação",
  "srv_trade_max_leverage": "A alavancagem máxima para {symbol} é {max}x",
  "srv_trade_risk_range": "O risco para {symbol} deve ser entre 1% e {max}%",
  "srv_payment_unsupported_currency": "Moeda não compatível. Escolha uma: {list}",
  "srv_exchange_unsupported_named": "Exchange não compatível: {name}",
  "srv_auth_username_cooldown": "O nome de usuário poderá ser alterado novamente em {days} dia(s)",
  "srv_exchange_connection_error": "Erro de conexão: {error}",
  "srv_trade_early_fee": "Taxa de retirada antecipada de 5% ({fee}) aplicada.",
  "ntf_risk_drawdown": "Drawdown máximo de {dd}% atingiu o limite de {limit}%. Todas as posições foram fechadas. Bot pausado.",
  "ntf_risk_losses": "{count} perdas consecutivas. Bot pausado. Confirme para retomar.",
  "ntf_cooldown": "Em espera após {count} perdas consecutivas — novas entradas pausadas por {minutes} min.",
  "ntf_trade_opened": "Operação aberta: {symbol} {timeframe} · score {score} · {leverage}",
  "ntf_nft_opened": "Posição NFT aberta (Demo): {name}",
  "ntf_nft_closed": "Posição NFT fechada (Demo): P&L {pnl}",
  "ntf_trade_closed": "{reason}: {symbol} fechada · P&L {pnl}",
  "ntf_opportunity": "⚠️ {symbol} · {timeframe} · {action} · Score {score}. Entrada ${entry} / TP ${tp} / SL ${sl}. Apenas informativo — não é recomendação financeira.",
  "app_name": "FIREBIRD AI",
  "tagline": "Negocie cripto e NFTs com IA",
  "login": "Entrar",
  "register": "Criar conta",
  "logout": "Sair",
  "email": "E-mail",
  "password": "Senha",
  "name": "Nome",
  "welcome_back": "Bem-vindo de volta, trader",
  "create_account": "Crie sua conta",
  "no_account": "Ainda não tem conta?",
  "have_account": "Já tem uma conta?",
  "account_created": "Conta criada — sua conta demo de $100 está pronta",
  "loading": "Carregando…",
  "demo_mode": "Modo demo",
  "demo_balance": "Saldo demo",
  "nav_dashboard": "Painel",
  "nav_charts": "Gráficos ao vivo",
  "nav_signals": "Sinais de IA",
  "nav_autotrade": "Negociação automática",
  "nav_manual": "Negociação manual",
  "nav_scanner": "Scanner de memecoins",
  "nav_backtest": "Backtest 5×5",
  "nav_positions": "Posições e relatórios",
  "nav_nft": "Coleção NFT",
  "nav_assistant": "Assistente de IA",
  "nav_settings": "Corretora e configurações",
  "nav_subscription": "Plano Premium",
  "subscription_subtitle": "Desbloqueie análises de trading premium — pague com cripto.",
  "current_plan": "Plano atual",
  "premium": "Premium",
  "free_plan": "Plano gratuito",
  "renews_on": "Renova em",
  "active": "Ativo",
  "best_value": "Melhor valor",
  "plan_monthly": "Mensal",
  "plan_annual": "Anual",
  "plan_test": "Teste",
  "days": "d",
  "pay_with_crypto": "Pagar com cripto",
  "opening_checkout": "Abrindo o checkout…",
  "gateway_not_ready": "O gateway de pagamento em cripto ainda não está configurado. O checkout do Premium ficará disponível quando as chaves de API da NOWPayments forem adicionadas.",
  "premium_only": "Somente Premium",
  "premium_gate_desc": "Este recurso faz parte do FireBird Premium. Faça o upgrade para desbloquear todos os sinais de IA, negociação automática e o scanner de oportunidades.",
  "go_premium": "Fazer upgrade para Premium",
  "billing_history": "Histórico de pagamentos",
  "no_invoices": "Nenhuma fatura ainda. Seus pagamentos em cripto aparecerão aqui.",
  "date": "Data",
  "plan_col": "Plano",
  "amount_col": "Valor",
  "status_col": "Status",
  "view_invoice": "Ver fatura",
  "check_status": "Verificar status do pagamento",
  "checking": "Verificando…",
  "payment_still_pending": "Pagamento ainda não confirmado. Vamos verificar automaticamente.",
  "status_paid": "Pago",
  "status_created": "Pendente",
  "status_partially_paid": "Parcialmente pago",
  "status_expired": "Expirado",
  "status_failed": "Falhou",
  "status_refunded": "Reembolsado",
  "status_cancelled": "Cancelado",
  "status_canceled": "Cancelado",
  "payment_processing": "Pagamento detectado — ativando seu plano Premium…",
  "payment_success": "Premium ativado. Bem-vindo!",
  "payment_cancelled": "Pagamento cancelado.",
  "payment_error": "Não foi possível iniciar o checkout. Tente novamente.",
  "popup_blocked": "Checkout pronto. Se a nova aba não abriu, use o link abaixo.",
  "checkout_opened_hint": "Checkout aberto em uma nova aba. Não aparece?",
  "open_checkout": "Abrir checkout",
  "pay_currency_label": "Pagar com",
  "pay_currency_hint": "Aceitamos USDC na Solana e BNB na BSC. O ativo escolhido é fixado no checkout.",
  "feat_signals": "Sinais de IA completos (cripto, shitcoins, NFTs)",
  "feat_autotrade": "Negociação automática com controle de risco",
  "feat_scanner": "Scanner de memecoins e oportunidades",
  "feat_alerts": "Alertas inteligentes por e-mail",
  "feat_priority": "Entrega prioritária de sinais",
  "feat_save": "2 meses grátis em relação ao plano mensal",
  "feat_test_quick": "Teste único de $1 — valida o fluxo real de pagamento",
  "demo_account_settings": "Configurações da conta demo",
  "demo_settings_desc": "Defina seu saldo demo e redefina sua conta de treino. Isso afeta apenas dados demo — sua assinatura e negociações reais não são afetadas.",
  "custom_demo_balance": "Saldo demo personalizado (USDC)",
  "demo_min_hint": "Padrão 500 · mínimo 100",
  "reset_demo_account": "Redefinir conta demo",
  "reset_demo_confirm_title": "Redefinir conta demo?",
  "reset_demo_confirm_desc": "Seu saldo demo será definido como ${bal}, todas as operações demo e o histórico de P/L serão apagados, e os estados de drawdown, parada e resfriamento serão redefinidos. Isso não pode ser desfeito. Sua assinatura e dados reais não são afetados.",
  "demo_reset_done": "Conta demo redefinida — saldo definido como ${bal}",
  "demo_min_balance_error": "O saldo demo mínimo é 100",
  "nav_guide": "Guia para iniciantes",
  "owner_console": "Console do proprietário",
  "total_value": "Valor total",
  "cash": "Dinheiro",
  "holdings": "Ativos",
  "unrealized_pnl": "PnL não realizado",
  "top_signals": "Melhores sinais de IA",
  "market_overview": "Visão geral do mercado",
  "whale_activity": "Baleias e dinheiro inteligente",
  "market_pulse": "Pulso do mercado",
  "news_up": "{name} subiu {pct}% em 24h",
  "news_down": "{name} caiu {pct}% em 24h",
  "kind_cex": "CEX",
  "kind_iranian_cex": "CEX iraniana",
  "kind_dex": "DEX",
  "price": "Preço",
  "change_24h": "24h",
  "score": "Pontuação",
  "action": "Ação",
  "buy": "Comprar",
  "sell": "Vender",
  "hold": "Manter",
  "timeframe": "Período",
  "symbol": "Símbolo",
  "amount_usd": "Valor (USD)",
  "open_position": "Abrir posição",
  "close": "Fechar",
  "no_positions": "Nenhuma posição aberta",
  "entry": "Entrada",
  "current": "Atual",
  "exit": "Saída",
  "reason": "Motivo",
  "pnl": "PnL",
  "win_rate": "Taxa de acerto",
  "total_trades": "Total de operações",
  "total_pnl": "PnL total",
  "wl": "G / P",
  "open_label": "Aberta",
  "run_backtest": "Executar backtest",
  "running": "Executando…",
  "bt_subtitle": "Estratégia testada em 5 janelas históricas por timeframe.",
  "window_results": "Resultados por janela",
  "window": "Janela",
  "trades": "Operações",
  "return_label": "Retorno",
  "max_drawdown": "Drawdown máx.",
  "auto_trade_on": "Negociação automática ativa",
  "auto_trade_off": "Negociação automática desligada",
  "enable_autotrade": "Ativar negociação automática (demo)",
  "reset_demo": "Redefinir demo ($100)",
  "activity_log": "Registro de atividade",
  "waiting_signals": "Aguardando sinais…",
  "enable_to_start": "Ative a negociação automática para começar",
  "reauthorize_bot": "Reautorizar bot",
  "leverage": "Alavancagem",
  "high_leverage_warning": "Alta alavancagem — você pode perder toda a margem (liquidação).",
  "bot_description": "O bot analisa todas as moedas em 15m / 1h / 4h, entra no melhor sinal (risco-retorno 2:1, stop obrigatório) e acompanha as posições com take-profit móvel no modo demo.",
  "rule_rr": "Lucro:Risco 2:1 (stop obrigatório)",
  "rule_max_concurrent": "Máx. 2 operações automáticas simultâneas",
  "rule_leverage": "Alavancagem auto ≤ 10x · Manual ≤ 50x",
  "rule_circuit": "Disjuntor de emergência com drawdown de 20%",
  "rule_halt": "Pausa após 5 perdas",
  "rule_scan": "Analisa todas as moedas e timeframes",
  "rule_entry": "Pontuação de entrada ≥ {score} em {tfs}",
  "rule_cooldown": "Resfriamento de {min} min após {losses} perdas",
  "risk_status": "Status de risco",
  "risk_mode_active": "Ativo",
  "risk_mode_halted": "Pausado",
  "consecutive_losses_label": "Perdas seguidas",
  "drawdown_label": "Rebaixamento",
  "open_positions_label": "Posições abertas",
  "max_concurrent_reached": "Máximo de operações simultâneas atingido.",
  "bot_reauthorized": "Bot reautorizado. Você pode ativar a negociação automática novamente.",
  "cloud_trading": "Negociação na nuvem",
  "enable_cloud": "Ativar negociação na nuvem",
  "disable_cloud": "Desativar negociação na nuvem",
  "cloud_status": "Status da nuvem",
  "cloud_on": "Em execução 24/7",
  "cloud_off": "Desligado",
  "cloud_desc": "O bot roda em nossos servidores 24/7, mesmo com seu dispositivo desligado.",
  "notifications": "Notificações",
  "no_notifications": "Nenhuma notificação ainda",
  "mark_all_read": "Marcar tudo como lido",
  "connect_exchange": "Conectar corretora",
  "api_key": "Chave de API",
  "api_secret": "Segredo de API",
  "api_key_optional": "Chave de API (opcional para preços públicos)",
  "connect": "Conectar",
  "test": "Testar",
  "remove": "Remover",
  "verified": "Verificada",
  "not_verified": "Não verificada",
  "connected_exchanges": "Corretoras conectadas",
  "aggregated_balances": "Saldos · Todas as corretoras",
  "aggregated_prices": "Preços ao vivo · Todas as corretoras",
  "no_connections": "Nenhuma corretora conectada ainda.",
  "connect_wallet": "Conectar carteira",
  "wallet_connected": "Carteira conectada",
  "wallet_note": "Não custodial — nunca guardamos suas chaves privadas.",
  "wallet_security": "Carteira e segurança",
  "wallet_never_ask": "Nunca pedimos sua chave privada ou frase-semente.",
  "disconnect_wallet": "Desconectar carteira",
  "switch_chain": "Trocar rede",
  "native_balance": "Saldo do token nativo",
  "wallet_chain": "Rede",
  "dex_onchain": "DEX (on-chain)",
  "sign_in_wallet": "Entrar com carteira",
  "waiting_signature": "Aguardando assinatura da carteira…",
  "dex_demo_note": "Você assina com a sua carteira — as chaves nunca saem do seu dispositivo.",
  "view_on_explorer": "Ver no explorador",
  "wallet_required_dex": "Conecte uma carteira para negociar on-chain.",
  "tx_pending": "Transação pendente…",
  "tx_confirmed": "Transação confirmada",
  "tx_failed": "Transação falhou",
  "connected_label": "Conectada",
  "not_connected_label": "Não conectada",
  "copy_address": "Copiar endereço",
  "readonly_warning": "Crie uma chave de API SOMENTE LEITURA. Desative saques e negociação.",
  "cex_security_notice": "NUNCA guardamos suas chaves privadas nem pedimos permissão de saque.",
  "api_passphrase_optional": "Frase secreta (opcional)",
  "read_only_label": "Somente leitura",
  "how_to_create_key": "Como criar uma chave somente leitura",
  "connected_wallets": "Carteiras conectadas",
  "no_wallet_connected": "Nenhuma carteira conectada.",
  "no_exchange_linked": "Nenhuma corretora vinculada.",
  "smart_contract_allowances": "Permissões de contratos inteligentes",
  "no_allowances": "Nenhuma permissão ativa.",
  "revoke": "Revogar",
  "max_spend": "Gasto máx.",
  "link_readonly_hint": "Use o painel \"Conectar corretora\" para vincular uma chave somente leitura.",
  "vpn_notice": "Para usuários de algumas regiões, este marketplace pode exigir VPN.",
  "ir_friendly": "Compatível com o Irã",
  "best_price": "Melhor preço",
  "marketplace_listings": "Anúncios do marketplace",
  "tab_opps": "Oportunidades",
  "opportunities": "Oportunidades",
  "high_opportunity": "Alta oportunidade",
  "alerts_triggered_today": "alertas hoje",
  "score_range": "Faixa de pontuação",
  "timeframe_label": "Período",
  "direction_label": "Direção",
  "risk_disclaimer_title": "Aviso de risco",
  "risk_disclaimer": "Os sinais são apenas informativos. Isto NÃO é aconselhamento financeiro. 98% das shitcoins falham. Use sempre stop-loss. Nunca arrisque mais de 1–5% por operação.",
  "no_opportunities": "Nenhuma oportunidade no momento. O scanner roda a cada 5 minutos.",
  "alerts_title": "Alertas",
  "enable_scanner": "Ativar scanner automático",
  "min_score_label": "Pontuação mínima",
  "monitor_timeframes": "Timeframes monitorados",
  "max_alerts_day": "Máx. de alertas por dia",
  "notify_method_label": "Método de notificação",
  "notify_in_app": "Somente no app",
  "notify_in_app_email": "No app + e-mail",
  "alert_history_title": "Histórico de alertas",
  "no_alert_history": "Nenhum alerta ainda.",
  "nft_markets": "Marketplaces de NFT",
  "iran_friendly": "Compatível com o Irã",
  "key_security_note": "As chaves são criptografadas no servidor e nunca armazenadas no seu navegador.",
  "exchange": "Corretora",
  "no_balances": "Sem saldos (adicione chaves de API para carregar saldos ao vivo).",
  "safety": "Segurança",
  "opportunity": "Oportunidade",
  "holders": "Detentores",
  "verdict": "Veredito",
  "coin": "Moeda",
  "chain": "Rede",
  "scanning": "Escaneando…",
  "scanner_subtitle": "Memecoins selecionadas com liquidez negociável (pontuação ≥ 75). Tokens desconhecidos e golpes não são exibidos.",
  "safety_note": "Segurança = liquidez bloqueada + mint renunciado + distribuição de holders (estimativa, não é aconselhamento financeiro).",
  "ask_ai": "Pergunte à Firebird AI...",
  "send": "Enviar",
  "chat": "Chat",
  "ai_empty": "Pergunte sobre uma moeda, timeframe ou estratégia. Nada aqui é aconselhamento financeiro.",
  "ai_thinking": "Firebird AI está pensando…",
  "ai_error": "Desculpe, não consegui responder agora.",
  "score_coin": "Pontuar esta moeda",
  "any_coin_symbol": "Qualquer símbolo de moeda",
  "analyzing": "Analisando…",
  "entry_strategy": "Entrada",
  "exit_strategy": "Saída",
  "risk": "Risco",
  "signals_subtitle": "Pontuação de IA + técnica em todas as moedas",
  "momentum": "Momentum",
  "simulated_feed": "feed simulado",
  "collection": "Coleção Firebird 555",
  "nft_subtitle": "Firebird / Fênix — 555 itens · 6 raridades lendárias · cada uma com sua história de destruição e renascimento",
  "rares": "Raridades lendárias",
  "floor_price": "Preço mínimo",
  "minted": "Mintados",
  "total_supply": "Oferta total",
  "rarity": "Raridade",
  "bt_download": "Baixar",
  "bt_stop_loss": "Stop loss (TP = 2× SL)",
  "bt_min_score": "Score mín. do sinal",
  "bt_share": "Compartilhar",
  "bt_history": "Execuções de backtest salvas",
  "bt_card_saved": "Card de resultado baixado",
  "bt_compare_tf": "Comparar timeframes",
  "bt_best": "MELHOR",
  "bt_worst": "PIOR",
  "bt_run_all": "Executar todas as moedas",
  "bt_by_section": "Resultados por seção",
  "bt_per_coin": "Resultados por moeda",
  "bt_avg_return": "Retorno médio",
  "bt_skipped": "Ignorado (dados insuficientes)",
  "bt_sec_major": "Principais",
  "bt_sec_shitcoin": "Shitcoin",
  "bt_sec_meme": "Meme",
  "bt_sec_nft": "Tokens NFT",
  "bt_sec_other": "Outros",
  "bt_data_live": "Dados de mercado AO VIVO",
  "bt_data_simulated": "Dados SIMULADOS (mercado ao vivo indisponível)",
  "risk_per_trade": "Risco por operação",
  "max_amount": "Máx.",
  "tier_major": "Grandes",
  "tier_mid": "Médio porte",
  "tier_meme": "Meme/Pump",
  "high_risk_ack": "Entendo que esta é uma operação de ALTO RISCO (mais de 15% do meu saldo).",
  "lev_warn_yellow": "Alto risco de liquidação",
  "lev_warn_red": "Alavancagem extrema — risco de liquidação muito alto. Confirmação dupla necessária.",
  "lev_ack": "Entendo que posso perder toda a minha margem.",
  "lev_confirm_again": "Alavancagem extrema: clique novamente para confirmar.",
  "confirm_again": "Confirmar novamente",
  "high_risk_required": "Marque a confirmação de alto risco.",
  "lev_ack_required": "Confirme o aviso de alavancagem extrema.",
  "trait_element": "Elemento",
  "trait_aura": "Aura",
  "trait_background": "Fundo",
  "prev": "Voltar",
  "next": "Próximo",
  "all": "Todos",
  "save": "Salvar",
  "risk_lock": "Proteção de risco",
  "max_position": "Posição máx. %",
  "trailing_stop": "Stop móvel %",
  "take_profit": "Take-profit %",
  "stop_loss": "Stop-loss %",
  "risk_strategy": "Risco e estratégia",
  "exchanges": "Conexões com corretoras",
  "connected": "Conectada",
  "disconnected": "Não conectada",
  "withdraw_demo_wallet": "Saque (carteira demo)",
  "withdraw_fee_note": "Saques feitos em menos de 7 dias após o último depósito têm taxa de 5% por saque antecipado (parte do proprietário).",
  "withdraw": "Sacar",
  "trade_history": "Histórico de operações",
  "no_closed_trades": "Nenhuma operação fechada ainda",
  "owner_subtitle": "Desempenho de todos os usuários (somente leitura) · registro de taxas (2% por operação lucrativa, liquidação semanal · 5% por saque antecipado)",
  "total_users": "Total de usuários",
  "total_commission": "Total de taxas",
  "this_week": "Esta semana",
  "total_volume": "Volume total",
  "all_time": "desde o início",
  "settles_weekly": "liquidado semanalmente",
  "commission_breakdown": "Detalhamento das taxas",
  "from_trade_profits": "Do lucro das operações (2%)",
  "from_withdrawal_fees": "Das taxas de saque antecipado (5%)",
  "owner_rate": "Taxa do proprietário",
  "settlement": "Liquidação",
  "early_exit_fee": "Taxa de saída antecipada",
  "weekly": "Semanal",
  "daily_accrual": "Acumulado diário",
  "no_commission_yet": "Nenhuma taxa ainda — elas se acumulam a partir de operações lucrativas.",
  "users_performance": "Desempenho dos usuários (somente leitura)",
  "col_user": "Usuário",
  "col_role": "Função",
  "col_joined": "Data de cadastro",
  "col_volume": "Volume",
  "col_balance": "Saldo",
  "role_owner": "proprietário",
  "role_user": "usuário",
  "guide_intro": "Bem-vindo à Firebird AI Trade. Siga estes passos para começar com segurança.",
  "guide_step": "Passo",
  "guide1_title": "Modo demo ativado",
  "guide1_desc": "Você começa com um saldo demo de $100. Nenhum dinheiro real é usado até que você ative explicitamente a negociação real com suas próprias chaves seguras.",
  "guide2_title": "Explore o painel",
  "guide2_desc": "Valor do portfólio, melhores sinais de IA, visão geral do mercado, atividade das baleias e pulso do mercado — tudo em um só lugar.",
  "guide3_title": "Confira os sinais de IA",
  "guide3_desc": "As moedas são pontuadas de 0 a 100 com base em RSI, cruzamentos de SMA e momentum em vários timeframes.",
  "guide4_title": "Pergunte ao assistente de IA",
  "guide4_desc": "Receba uma pontuação da moeda com estratégia de entrada/saída e notas de risco da Firebird AI Core (GPT-5.6).",
  "guide5_title": "Experimente a negociação automática (demo)",
  "guide5_desc": "Deixe o bot abrir posições de compra em sinais fortes e acompanhá-las com stop móvel / take-profit.",
  "guide6_title": "Escaneie memecoins",
  "guide6_desc": "Apenas memecoins negociáveis com alta pontuação de segurança são exibidas — sem tokens desconhecidos ou golpes.",
  "guide7_title": "Explore os NFTs Firebird 555",
  "guide7_desc": "Navegue pela coleção de 555 fênix com 6 raridades lendárias.",
  "disclaimer": "Demo/sandbox. Nada aqui é aconselhamento financeiro. Nenhum sistema pode garantir uma taxa de acerto futura.",
  "src_manual": "Manual",
  "src_auto": "Automático",
  "tier_legendary": "Lendário",
  "tier_epic": "Épico",
  "tier_rare": "Raro",
  "tier_common": "Comum",
  "verdict_tradeable": "Negociável",
  "verdict_watch": "Observar",
  "pressure_accumulation": "Acumulação",
  "pressure_distribution": "Distribuição",
  "reason_take_profit": "Take-profit",
  "reason_liquidation": "Liquidação",
  "reason_stop_loss": "Stop-loss",
  "reason_trailing_take_profit": "Take-profit móvel",
  "reason_trailing_stop": "Stop móvel",
  "reason_signal_flip": "Reversão de sinal",
  "welcome": "Bem-vindo",
  "trader": "trader",
  "live": "Ao vivo",
  "verify_email_banner": "Confirme seu e-mail para abrir operações. Procure o link de confirmação na sua caixa de entrada.",
  "resend": "Reenviar",
  "verification_sent": "E-mail de confirmação enviado",
  "could_not_resend": "Não foi possível reenviar",
  "search_coin_placeholder": "Pesquise qualquer moeda (ex.: BTC, PEPE, ARB)",
  "add_to_watchlist": "Adicionar à lista de observação",
  "free_balance": "Saldo livre",
  "in_positions": "Em posições",
  "total_equity": "Patrimônio total",
  "watchlist": "Lista de observação",
  "watchlist_empty": "Nenhuma moeda ainda — pesquise e toque em + para adicionar.",
  "high_exposure": "Usando {percent}% do seu saldo livre — alta exposição.",
  "advanced_tpsl": "TP / SL avançado",
  "entry_optional": "Entrada (opcional — padrão a mercado)",
  "market": "mercado",
  "take_profit_price": "Preço de take-profit",
  "stop_loss_price": "Preço de stop-loss",
  "tp_example": "ex.: 72000",
  "sl_example": "ex.: 66000",
  "if_tp_hits": "Se o TP for atingido",
  "if_sl_hits": "Se o SL for atingido",
  "pnl_preview_note": "Com base na margem de ${amount} × {leverage}x. Linhas desenhadas no gráfico →",
  "clear_tpsl": "Limpar TP/SL",
  "one_tap_trade": "Negociação com um toque",
  "tp_short": "TP",
  "sl_short": "SL",
  "auto_signals": "Sinais automáticos",
  "add_token_placeholder": "Adicione qualquer token (ex.: ARB, OP, TIA)",
  "analyze": "Analisar",
  "analyzing_on": "Analisando {symbol} em {tf}…",
  "tap_to_load": "Toque para carregar no gráfico →",
  "scanning_market": "Escaneando o mercado…",
  "no_signals": "Nenhum sinal ainda.",
  "money_depth": "Profundidade de dinheiro do mercado",
  "sr_zones": "Zonas de suporte/resistência",
  "bot_analysis": "Análise do bot",
  "confidence": "Confiança",
  "reasoning": "Justificativa",
  "tp_label": "Take-profit",
  "sl_label": "Stop-loss",
  "risk_reward": "Risco : Retorno",
  "levels_from_position": "Níveis ao vivo da sua posição aberta",
  "levels_suggested": "Níveis sugeridos · não é aconselhamento financeiro",
  "toast_opened": "Posição {symbol} {leverage}x aberta",
  "toast_closed": "{symbol} fechada · PnL ${pnl}",
  "toast_closed_pnl": "Fechada · PnL ${pnl}",
  "ago_s": "há {n}s",
  "ago_m": "há {n}min",
  "ago_h": "há {n}h",
  "ago_d": "há {n}d",
  "in_label": "Entrada de fluxo",
  "out_label": "Saída de fluxo",
  "confirm_reveal_email": "Mostrar o e-mail deste usuário? O e-mail é confidencial — veja apenas se necessário.",
  "view_email_private": "Mostrar e-mail (confidencial)",
  "display_name_updated": "Nome de exibição atualizado",
  "change_email_sent": "Link de confirmação enviado para o novo e-mail",
  "username_updated": "Nome de usuário atualizado",
  "password_changed": "Senha alterada. Entre novamente nos outros dispositivos.",
  "confirm_logout_all": "Sair de todos os dispositivos? Você precisará entrar novamente.",
  "no_wallet": "Extensão de carteira não detectada (MetaMask/WalletConnect).",
  "wallet_rejected": "Conexão da carteira recusada.",
  "profile_security": "Perfil e segurança",
  "display_name": "Nome de exibição",
  "display_name_optional": "Nome de exibição (opcional)",
  "edit": "Editar",
  "cancel": "Cancelar",
  "change": "Alterar",
  "in_days": "Em {days}d",
  "username_label": "Nome de usuário",
  "username_hint": "3–20 letras, números ou sublinhados. Pode ser alterado a cada 30 dias.",
  "username_example": "ex.: arash_king",
  "email_private": "E-mail (confidencial)",
  "change_email": "Alterar e-mail",
  "unverified": "Não confirmado",
  "resend_verification": "Reenviar confirmação",
  "new_email": "Novo e-mail",
  "current_password": "Senha atual",
  "new_password": "Nova senha",
  "confirm_new_password": "Confirme a nova senha",
  "send_verification_new": "Enviar confirmação para o novo e-mail",
  "change_email_hint": "Você confirmará a alteração pelo link enviado ao novo e-mail e depois entrará novamente.",
  "email_private_hint": "Seu e-mail nunca é exibido publicamente. Só você o vê aqui.",
  "sessions": "Sessões",
  "logout_all_devices": "Sair de todos os dispositivos",
  "change_password": "Alterar senha",
  "pw_hint": "Mínimo de 8 caracteres, com letra e número.",
  "update_password": "Atualizar senha",
  "coin_example_placeholder": "ex.: BTC, PEPE, TAO...",
  "username_or_email": "Nome de usuário ou e-mail",
  "forgot_password_q": "Esqueceu a senha?",
  "invalid_email": "Digite um endereço de e-mail válido",
  "pw_mismatch": "As senhas não coincidem",
  "username_hint_short": "3–20 letras, números ou sublinhados",
  "account_created_verify": "Conta criada! Verifique seu e-mail para confirmar a conta.",
  "confirm_password_label": "Confirme a senha",
  "missing_verify_token": "Token de confirmação ausente.",
  "email_verified_msg": "E-mail confirmado!",
  "verification_failed": "Não foi possível confirmar.",
  "verifying_email": "Confirmando seu e-mail…",
  "email_verified_title": "E-mail confirmado",
  "go_to_login": "Ir para o login",
  "verification_failed_title": "Falha na confirmação",
  "verify_expired_hint": "O link expirou? Entre e use \"Reenviar confirmação\" nas configurações.",
  "back_to_login": "← Voltar ao login",
  "forgot_password": "Esqueci a senha",
  "forgot_subtitle": "Digite seu nome de usuário ou e-mail e enviaremos um link de redefinição.",
  "forgot_sent_toast": "Se a conta existir, um link de redefinição foi enviado.",
  "forgot_sent_full": "Se a conta existir, um link de redefinição foi enviado. Verifique seu e-mail (válido por 15 minutos).",
  "send_reset_link": "Enviar link de redefinição",
  "remembered_it": "Lembrou?",
  "missing_reset_token": "Token de redefinição ausente. Use o link do seu e-mail.",
  "pw_requirement": "A senha deve ter no mínimo 8 caracteres, com letra e número",
  "password_updated": "Senha atualizada.",
  "reset_password": "Redefinir senha",
  "reset_subtitle": "Escolha uma nova senha para sua conta.",
  "reset_invalid": "Link de redefinição inválido ou ausente. Solicite um novo.",
  "request_reset_link": "Solicitar link de redefinição",
  "new_password_label": "Nova senha",
  "pw_hint2": "Mínimo de 8 caracteres, com letra e número.",
  "update_password_btn": "Atualizar senha",
  "bullish": "Altista",
  "bearish": "Baixista",
  "inflow": "entrada",
  "outflow": "saída",
  "volume_up": "Volume subindo",
  "volume_down": "Volume caindo",
  "money_flow_mfi": "Fluxo de dinheiro (MFI 14)",
  "flow_overbought": "Sobrecomprado",
  "flow_oversold": "Sobrevendido",
  "flow_bullish": "Entrada altista",
  "flow_bearish": "Saída baixista",
  "support": "Suporte",
  "resistance": "Resistência",
  "available_for_trade": "Disponível para negociar",
  "free_balance_after": "Saldo livre após",
  "tab_major": "Grandes",
  "tab_shitcoins": "Shitcoins",
  "tab_nfts": "NFT",
  "filter_direction": "Direção",
  "buy_only": "Somente compra",
  "sell_only": "Somente venda",
  "min_confidence": "Confiança mín.",
  "confirm": "Confirmar",
  "safety_score": "Pontuação de segurança",
  "liquidity_lock": "Liquidez bloqueada",
  "locked": "Bloqueada",
  "unlocked": "Desbloqueada",
  "honeypot": "Honeypot",
  "honeypot_safe_label": "Seguro",
  "honeypot_risk": "Risco",
  "nft_demo_notice": "Operação demo — nenhum NFT real será comprado",
  "view_on_opensea": "Abrir na OpenSea",
  "volume_24h": "Volume (24h)",
  "nft_position_opened": "Posição NFT aberta (demo)",
  "crypto_positions_title": "Posições em cripto e shitcoins",
  "nft_positions_title": "Posições em NFT",
  "min_safety_required": "A pontuação de segurança deve ser ≥ 75 para negociar",
  "amount_exceeds_balance": "O valor excede seu saldo livre",
  "amount_gt_zero": "O valor deve ser maior que 0",
  "confirm_trade": "Confirmar operação",
  "usd_equiv": "≈",
  "nft_badge": "NFT",
  "no_nft_positions": "Nenhuma posição em NFT aberta",
  "floor": "Piso",
  "rr_short": "G:P",
  "best_marketplace": "Melhor mercado",
  "story": "Histórico",
  "show_more": "Mostrar mais",
  "show_less": "Mostrar menos",
  "view_chart": "Ver gráfico",
  "reason_sma_bull": "SMA9 acima da SMA21 (tendência de alta)",
  "reason_sma_bear": "SMA9 abaixo da SMA21 (tendência de baixa)",
  "reason_rsi_oversold": "sobrevendido",
  "reason_rsi_overbought": "sobrecomprado",
  "reason_rsi_neutral": "neutro",
  "reason_pos_momentum": "Momentum positivo",
  "reason_neg_momentum": "Momentum negativo",
  "reason_insufficient": "Dados insuficientes",
  "reason_whale_accum": "Acumulação por baleias",
  "reason_rising_floor": "Piso em alta",
  "reason_falling_floor": "Piso em queda",
  "reason_high_rarity": "Alta raridade",
  "reason_mid_rarity": "Média raridade",
  "nft_trade_history": "Histórico de operações com NFT",
  "no_nft_trades": "Nenhuma operação com NFT fechada ainda",
  "entry_floor": "Piso na entrada",
  "exit_floor": "Piso na saída",
  "verify_reminder": "Seu e-mail ainda não foi confirmado — confirme-o para liberar a negociação.",
  "verify_now": "Confirmar agora",
  "dismiss": "Dispensar",
  "trusted_devices": "Sessões ativas · Dispositivos conectados à sua conta",
  "font_size": "Tamanho da fonte",
  "font_small": "Pequeno",
  "font_medium": "Médio",
  "font_large": "Grande",
  "sessions_hint": "Celulares e navegadores conectados à sua conta (não são chaves de API de corretoras).",
  "unknown_device": "Dispositivo desconhecido",
  "this_device": "Este dispositivo",
  "current_session": "Atual",
  "last_active": "Última atividade",
  "revoke_all_others": "Sair de todos os outros dispositivos",
  "revoke_all_others_done": "Saída de todos os outros dispositivos concluída",
  "no_other_devices": "Nenhum outro dispositivo ativo",
  "device_revoked": "Dispositivo removido da conta",
  "ui_logo_alt": "Logo do Firebird / Simorgh Trade",
  "ui_logo_switch_hint": "Toque para trocar o logo",
  "ui_vpn_info": "Informações sobre VPN"
};
export default pt;
